/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { InstallerStatusEnum, InstallerPassTypeEnum } from '@bo-client/shared/models/installerPassDto';
import { networkOperatorList } from '@bo-client/core/api/data-lists/network-operator-list';
import {
  CommissioningPowerDeviceType,
  CommissioningStatusEnum,
  CommonStatusEnum,
  SupplyAppointmentPartDayStatusEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';
import { BusinessPartnerTypeEnum } from '@bo-client/business-partners/model/businessPartnerType';
import {
  GridRegistrationStatusEnum,
  ReactivePowerProvisioningMethod
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { FeederContractStatusEnum } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { Observable, of } from 'rxjs';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ConfigService } from '@bo-client/config/config.service';
import { combineLatestWith, map, shareReplay } from 'rxjs/operators';
import { SalutationsModel } from '@bo-client/shared/constants/salutations';
import { uri } from '@bo-client/shared/constants/uri';
import {
  CommissioningPowerActionTypeEnum,
  CommissioningPowerMeterTypeConstant
} from '@bo-client/activation-management/commissioning/forms/commissioning-data-enum';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { CodeListValue } from '@bo-client/shared/models/codeListValue';
import { ConnectionChangeRequestStatusConstant } from '@bo-client/shared/models/connectionChange.dto';

export interface StatusType {
  value: string;
  displayName?: string;
  cssColor?: string;
}

export interface TemplateType {
  value: string;
  displayName: string;
  entityClass?: string;
}

export interface Option {
  value: string;
  title: string;
  entityClass?: string;
}

@Injectable()
export class MetaService {
  getAreaText(area: string): any {
    return this.areas.find((a) => a.value === area)?.displayName;
  }
  public salutationValues$: Observable<SalutationsModel[]> = of([
    {
      title: 'Frau',
      id: '0001',
      type: 'Person'
    },
    {
      title: 'Herr',
      id: '0002',
      type: 'Person'
    },
    {
      title: 'Privatperson',
      id: '0004',
      type: 'Person'
    },
    {
      title: 'Firma',
      id: '0003',
      type: 'Organisation'
    },
    {
      title: 'Herr und Frau',
      id: '0006',
      type: 'Person'
    },
    {
      title: 'Herren',
      id: '0009',
      type: 'Person'
    },
    {
      title: 'Herrn / Herrn',
      id: '0012',
      type: 'Person'
    },
    {
      title: 'Frau / Frau',
      id: '0013',
      type: 'Person'
    },
    {
      title: 'Baugenossenschaft',
      id: '0017',
      type: 'Organisation'
    },
    {
      title: 'Bauherrengemeinsch.',
      id: '0018',
      type: 'Organisation'
    },
    {
      title: 'Eigentümergemeinsch.',
      id: '0019',
      type: 'Organisation'
    },
    {
      title: 'Erbengemeinschaft ',
      id: '0020',
      type: 'Organisation'
    }
  ]);

  public reactivePowerProvisioningMethods$ = of([
    {
      value: 'Q_U_STANDARD_CURVE',
      displayName: 'Q(U)-Standard-Kennlinie'
    },
    {
      value: 'COS_PHI_P_STANDARD_CURVE',
      displayName: 'Cos Phi (P)-Standard-Kennlinie'
    },
    {
      value: 'FIXED_DISPLACEMENT_FACTOR_COS_PHI',
      displayName: 'fester Verschiebungsfaktor cos Phi'
    }
  ]);

  public usageTypes$ = of([
    {
      value: 'G',
      displayName: 'Gewerbe'
    },
    {
      value: 'H',
      displayName: 'Haushalt'
    },
    {
      value: 'I',
      displayName: 'Industrie'
    },
    {
      value: 'L',
      displayName: 'Landwirtschaft'
    },
    {
      value: 'OE',
      displayName: 'Öffentliches Gebäude'
    },
    {
      value: 'S',
      displayName: 'Sonstiges'
    }
  ]);

  /**
   * LESS_20_DEGREE("< 20 Grad"),
   *   BETWEEN_20_40_DEGREE("20 - 40 Grad"),
   *   BETWEEN_40_60_DEGREE("40 - 60 Grad"),
   *   FACADE_INTEGRATED("Fassadenintegriert"),
   *   FOLLOWING("Nachgeführt");
   */
  public tiltValues$ = of([
    {
      value: 'LESS_20_DEGREE',
      displayName: '< 20 Grad'
    },
    {
      value: 'BETWEEN_20_40_DEGREE',
      displayName: '20 - 40 Grad'
    },
    {
      value: 'BETWEEN_40_60_DEGREE',
      displayName: '40 - 60 Grad'
    },
    {
      value: 'FACADE_INTEGRATED',
      displayName: 'Fassadenintegriert'
    },
    {
      value: 'FOLLOWING',
      displayName: 'Nachgeführt'
    }
  ]);
  /**
   * SOUTH("Süd"),
   *   SOUTH_WEST("Süd-West"),
   *   SOUTH_EAST("Süd-Ost"),
   *   WEST("West"),
   *   EAST_WEST("Ost-West"),
   *   EAST("Ost"),
   *   NORTH_WEST("Nord-West"),
   *   NORTH_EAST("Nort-Ost"),
   *   NORTH("Nord"),
   *   FOLLOWED("Nachgeführt");
   */
  public orientationValues$ = of([
    {
      value: 'SOUTH',
      displayName: 'Süd'
    },
    {
      value: 'SOUTH_WEST',
      displayName: 'Süd-West'
    },
    {
      value: 'SOUTH_EAST',
      displayName: 'Süd-Ost'
    },
    {
      value: 'WEST',
      displayName: 'West'
    },
    {
      value: 'EAST_WEST',
      displayName: 'Ost-West'
    },
    {
      value: 'EAST',
      displayName: 'Ost'
    },
    {
      value: 'NORTH_WEST',
      displayName: 'Nord-West'
    },
    {
      value: 'NORTH_EAST',
      displayName: 'Nord-Ost'
    },
    {
      value: 'NORTH',
      displayName: 'Nord'
    },
    {
      value: 'FOLLOWED',
      displayName: 'Nachgeführt'
    }
  ]);

  /**
   * public enum BatteryTechnologyEnum implements Titled {
   *   BATTERY('Batterie'),
   *   PUMP('Pumpspeicher'),
   *   AIR_PRESSURE('Druckluft'),
   *   NAME('Schwungrad'),
   *   FLY_WHEEL('Sonstige');
   */
  batteryTechnology$ = of([
    {
      value: 'BATTERY',
      displayName: 'Batterie'
    },
    {
      value: 'PUMP',
      displayName: 'Pumpspeicher'
    },
    {
      value: 'AIR_PRESSURE',
      displayName: 'Druckluft'
    },
    {
      value: 'NAME',
      displayName: 'Schwungrad'
    },
    {
      value: 'FLY_WHEEL',
      displayName: 'Sonstige'
    }
  ]);

  batteryType$ = of([
    {
      value: 'BLE',
      displayName: 'Blei-Batterie'
    },
    {
      value: 'HOC',
      displayName: 'Hochtemperaturbatterie'
    },
    {
      value: 'LIT',
      displayName: 'Lithium-Batterie'
    },
    {
      value: 'NIC',
      displayName: 'Nickel-Cadmium- / Nickel-Metallhydridbatterie'
    },
    {
      value: 'RED',
      displayName: 'Redox-Flow-Batterie'
    },
    {
      value: 'STG',
      displayName: 'Sonstige Batterie'
    }
  ]);

  voltageLevels$ = of([
    {
      value: 'Low',
      displayName: 'Niederspannung'
    },
    {
      value: 'Middle',
      displayName: 'Mittelspannung'
    },
    {
      value: 'High',
      displayName: 'Hochspannung'
    }
  ]);

  feederConnectionStandards$ = of([
    {
      value: 'VDE4105',
      displayName: 'VDE-AR-N 4105'
    },
    {
      value: 'VDE4110',
      displayName: 'VDE-AR-N 4110'
    }
  ]);

  rateLimitingTypes$ = of([
    {
      value: 'Direct',
      displayName: 'Einzelsteuerung als SteuVE'
    },
    {
      value: 'EMS',
      displayName: 'Steuerung über EMS'
    },
    {
      value: 'NotControlled',
      displayName: 'nicht steuerbar'
    }
  ]);

  filteredRateLimitingTypes$: Observable<{ value: string; displayName: string }[]>;

  constructor(
    private httpService: HttpHapService,
    private configService: ConfigService,
    private dataShareService: DataShareService
  ) {
    this.allTemplates$ = httpService.getTyped<Option[]>(`/meta/template-types`).pipe(
      map((data: Option[]): TemplateType[] =>
        data.map((template) => ({
          value: template.value,
          displayName: template.title,
          entityClass: template.entityClass
        }))
      ),
      shareReplay(1)
    );

    this.filteredRateLimitingTypes$ = this.rateLimitingTypes$.pipe(
      combineLatestWith(this.dataShareService.tenantConfig$),
      map((x) => {
        if (x[1].gridRegistration.p14aRateLimitingTypeOptions)
          return x[0].filter((y) => x[1].gridRegistration.p14aRateLimitingTypeOptions.includes(y.value));

        return x[0];
      })
    );
  }

  public codeListValues$(fieldName: string, tenantId: string): Observable<CodeListValue[]> {
    return this.httpService.get(uri.codeListValues + '/' + fieldName + '/' + tenantId).pipe(
      map((data: CodeListValue[] | null) => {
        return data || [];
      })
    );
  }

  public networkOperatorList = new networkOperatorList();

  public getOrderRequestStateValues() {
    return this.orderRequestStates;
  }

  public getFoundationTypeOptions() {
    return [
      {
        value: 'none',
        displayName: 'Keine'
      },
      {
        value: 'cobble',
        displayName: 'Pflaster/Platten'
      },
      {
        value: 'asphalt',
        displayName: 'Asphalt'
      }
    ];
  }

  public getOrderStates() {
    return this.orderStates;
  }

  orderRequestStates = [
    {
      value: '',
      displayName: 'Alle',
      cssColor: ''
    },
    {
      value: 'created',
      displayName: 'Angefragt',
      cssColor: '#71dde3'
    },
    {
      value: 'placed',
      displayName: 'Beauftragt',
      cssColor: '#C3E88D'
    },
    {
      value: 'creating_sap',
      displayName: 'Auftrag in Erstellung (SAP)',
      cssColor: ''
    },
    {
      value: 'confirmation_requested_by_mail',
      displayName: 'Angebot via Mail verschickt',
      cssColor: '#f0b429'
    },
    {
      value: 'error_creating_order',
      displayName: 'Fehler bei Auftragsanlage',
      cssColor: '#fd7e14'
    },
    {
      value: 'approved',
      displayName: 'Freigegeben',
      cssColor: '#C3E88D'
    },
    {
      value: 'under_construction',
      displayName: 'In Bau',
      cssColor: '#C3E88D'
    },
    {
      value: 'in_progress',
      displayName: 'In Bearbeitung',
      cssColor: '#C3E88D'
    },
    {
      value: 'technically_completed',
      displayName: 'Techn. abgeschlossen',
      cssColor: '#e99aa6'
    },
    {
      value: 'commercially_completed',
      displayName: 'Kaufm. abgeschlossen',
      cssColor: '#e99aa6'
    },
    {
      value: 'canceled',
      displayName: 'Storniert',
      cssColor: '#e99aa6'
    }
  ];

  orderStates = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'created',
      displayName: 'Nicht angelegt'
    },
    {
      value: 'placed',
      displayName: 'Offen'
    },
    {
      value: 'creating_sap',
      displayName: 'Auftrag in Erstellung (SAP)'
    },
    {
      value: 'confirmation_requested_by_mail',
      displayName: 'Angebot via Mail verschickt'
    },
    {
      value: 'error_creating_order',
      displayName: 'Fehler bei Auftragsanlage'
    },
    {
      value: 'approved',
      displayName: 'Freigegeben'
    },
    {
      value: 'under_construction',
      displayName: 'In Bau'
    },
    {
      value: 'in_progress',
      displayName: 'In Bearbeitung'
    },
    {
      value: 'technically_completed',
      displayName: 'Techn. abgeschlossen'
    },
    {
      value: 'commercially_completed',
      displayName: 'Kaufm. abgeschlossen'
    },
    {
      value: 'canceled',
      displayName: 'Storniert'
    }
  ];

  public getBuildingTypes() {
    return [
      {
        name: 'Ein-/Zwei-Familienhaus',
        value: 'Single'
      },
      {
        name: 'Mehr-Familienhaus',
        value: 'Multi'
      },
      {
        name: 'Gewerbe',
        value: 'Business'
      }
    ];
  }

  public getStateFilterOptions() {
    return [
      {
        name: 'Nicht angelegt',
        state: 'created'
      },
      {
        name: 'Offen',
        state: 'placed'
      },
      {
        name: 'Freigegeben',
        state: 'approved'
      },
      {
        name: 'Techn. abgeschlossen',
        state: 'technically_completed'
      },
      {
        name: 'Kaufm. abgeschlossen',
        state: 'commercially_completed'
      },
      {
        name: 'Storniert',
        state: 'cancelled'
      },
      {
        name: 'Fehler',
        state: 'error_creating_order'
      }
    ];
  }

  public getStateAndAreaFilterOptions() {
    return [
      {
        name: 'S. Offen',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'placed'
      },
      {
        name: 'S. Freigegeben',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'approved'
      },
      {
        name: 'S. Techn. abgeschlossen',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'technically_completed'
      },
      {
        name: 'S. Kaufm. abgeschlossen',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'commercially_completed'
      },
      {
        name: 'S. Storniert',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'cancelled'
      },
      {
        name: 'S. Fehler',
        area: 'Power',
        displayGroup: 'Strom',
        state: 'error_creating_order'
      },
      {
        name: 'G. Offen',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'placed'
      },
      {
        name: 'G. freigegeben',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'approved'
      },
      {
        name: 'G. Techn. abgeschlossen',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'technically_completed'
      },
      {
        name: 'G. Kaufm. abgeschlossen',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'commercially_completed'
      },
      {
        name: 'G. Storniert',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'cancelled'
      },
      {
        name: 'G. Fehler',
        area: 'Gas',
        displayGroup: 'Gas',
        state: 'error_creating_order'
      },
      {
        name: 'Leerrohr. Offen',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'placed'
      },
      {
        name: 'Leerrohr. Freigegeben',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'approved'
      },
      {
        name: 'Leerrohr. Techn. abgeschlossen',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'technically_completed'
      },
      {
        name: 'Leerrohr. Kaufm. abgeschlossen',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'commercially_completed'
      },
      {
        name: 'Leerrohr. Storniert',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'cancelled'
      },
      {
        name: 'Leerrohr. Fehler',
        area: 'Lwl',
        displayGroup: 'Lwl',
        state: 'error_creating_order'
      }
      // ,
      // {
      //   name: 'Glasfaser. Offen',
      //   area: 'Lwlk',
      //   displayGroup: "Lwlk",
      //   state: 'placed',
      // },
      // {
      //   name: 'Glasfaser. Freigegeben',
      //   area: 'Lwlk',
      //   displayGroup: "Lwlk",
      //   state: 'approved',
      // },
      // {
      //   name: 'Glasfaser. Techn. abgeschlossen',
      //   area: 'Lwlk',
      //   displayGroup: "Lwlk",
      //   state: 'technically_completed',
      // },
      // {
      //   name: 'Glasfaser. Kaufm. abgeschlossen',
      //   area: 'Lwlk',
      //   displayGroup: "Lwlk",
      //   state: 'commercially_completed',
      // },
      // {
      //   name: 'Glasfaser. Storniert',
      //   area: 'Lwlk',
      //   displayGroup: "Lwl",
      //   state: 'cancelled',
      // },
      // {
      //   name: 'Glasfaser. Fehler',
      //   area: 'Lwlk',
      //   displayGroup: "Lwlk",
      //   state: 'error_creating_order',
      // }
    ];
  }

  public getRegionValues() {
    return this.regions;
  }

  regions = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'TBS',
      displayName: 'TBS'
    },
    {
      value: 'TRS',
      displayName: 'TRS'
    },
    {
      value: 'TBW',
      displayName: 'TBW'
    }
  ];

  public getAreaValues() {
    return this.areas;
  }

  // Todo: refactor areatypes
  areas = [
    {
      value: 'Power',
      displayName: 'Strom'
    },
    {
      value: 'Gas',
      displayName: 'Erdgas'
    },
    {
      value: 'LWL',
      displayName: 'Leerrohr'
    },
    {
      value: 'LWLK',
      displayName: 'Glasfaser'
    },
    {
      value: 'Water',
      displayName: 'Wasser'
    }
  ];

  public getQuestionTypes() {
    return this.questionTypes;
  }

  questionTypes = [
    {
      value: 'doc',
      displayName: 'Dokumenten-Upload'
    },
    {
      value: 'question',
      displayName: 'Bestätigung (Checkbox)'
    },
    {
      value: 'license',
      displayName: 'Fremdausweis'
    },
    {
      value: 'renewDoc',
      displayName: 'Dokument für Ausweisverlängerung'
    },
    {
      value: 'renewQuestion',
      displayName: 'Frage für Ausweisverlängerung'
    }
  ];

  public getTmInstallerTypes() {
    return this.tmInstallerTypes;
  }

  tmInstallerTypes: { value: string; displayName: string }[] = [
    {
      value: InstallerPassTypeEnum.pass,
      displayName: 'Installateurausweis'
    },
    {
      value: InstallerPassTypeEnum.license,
      displayName: 'Gastgenehmigung'
    }
  ];

  public getTmInstallerTypesForQuestions() {
    return this.tmInstallerTypesForQuestions;
  }

  tmInstallerTypesForQuestions = [
    {
      value: 'pass',
      displayName: 'Installateurausweis'
    },
    {
      value: 'license',
      displayName: 'Gastgenehmigung'
    },
    {
      value: 'renew',
      displayName: 'Gast-Installateurausweis Verlängerung'
    },
    {
      value: 'renewPass',
      displayName: 'Installateurausweis Verlängerung'
    },
    {
      value: 'renewLicense',
      displayName: 'Gastausweis Verlängerung'
    }
  ];

  public getDocumentTypes() {
    return this.documentTypes;
  }

  documentTypes = [
    {
      value: 'plaene',
      displayName: 'Plan'
    },
    {
      value: 'connectionDrawing',
      displayName: 'Anschlusszeichnung'
    },
    {
      value: 'pictures',
      displayName: 'Bild'
    },
    {
      value: 'eigentuemer',
      displayName: 'Eigentümer Bestätigung'
    },
    {
      value: 'steuer',
      displayName: 'Ust. Bestätigung'
    },
    {
      value: 'vertrag',
      displayName: 'Vertrag'
    },
    {
      value: 'dienstbarkeit',
      displayName: 'Dienstbarkeit'
    },
    {
      value: 'bbs_approval',
      displayName: 'Bestätigung Schornsteinfeger'
    },
    {
      value: 'consumptionUnder30kw',
      displayName: 'Nachweis Eigenverbrauch'
    },
    {
      value: 'gridRegistrationDoc',
      displayName: 'Netzanmeldung'
    },
    {
      value: 'hoehenschnitt',
      displayName: 'Höhenschnitt'
    },
    {
      value: 'grundriss',
      displayName: 'Grundriss'
    },
    {
      value: 'datenerfassung',
      displayName: 'Datenerfassung'
    },
    {
      value: 'stornierung',
      displayName: 'Stornierung'
    },
    {
      value: 'construction_file',
      displayName: 'Bauakte'
    },
    {
      value: 'schriftverkehr',
      displayName: 'Schriftverkehr'
    },
    {
      value: 'gutschrift',
      displayName: 'Gutschrift'
    },
    {
      value: 'vollmacht',
      displayName: 'Vollmacht'
    },
    {
      value: 'kampfmittel_dokumente',
      displayName: 'Kampfmitteldokumente'
    }
  ];

  public allTemplates$: Observable<TemplateType[]>;

  public getMailTemplateTypes() {
    return this.mailTemplateTypes;
  }

  public getAllTemplateTypes() {
    return this.allTemplates;
  }

  allTemplates: TemplateType[] = [
    {
      value: 'DEFAULT',
      displayName: 'Default'
    },
    {
      value: 'OFFER_REQUEST_CONFIRMATION',
      displayName: 'Bestätigung Angebotsanfrage'
    },
    {
      value: 'ORDER_CONFIRMATION',
      displayName: 'Bestellbestätigung'
    },
    {
      value: 'ORDER_CONFIRMATION_REQUEST',
      displayName: 'Anfrage Vertragsbestätiung durch Kunden'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER',
      displayName: 'Auftragsbestätigung - Anschreiben'
    },
    {
      value: 'ORDER_REQUEST_LETTER',
      displayName: 'Angebot - Anschreiben'
    },
    {
      value: 'CANCELLATION_LETTER',
      displayName: 'Absage - Anschreiben'
    },
    {
      value: 'BREAKUP_NOTICE',
      displayName: 'Aufbruchanzeige - Anschreiben'
    },
    {
      value: 'BUYING_CONTRACT',
      displayName: 'Kaufvertrag - Hausanschlusskasten'
    },
    {
      value: 'NEW_MESSAGE_NOTIFICATION',
      displayName: 'Chat - Neue Nachricht'
    },
    {
      value: 'MAIL_CONFIRMATION_REQUEST',
      displayName: 'Mail Bestätigung - Mail'
    },
    {
      value: 'PASSWORD_CHANGE_REQUEST',
      displayName: 'Passwort ändern - Mail'
    },
    {
      value: 'TM_WELLCOME_ADMIN_INSTALLATEUR',
      displayName: 'Inst. - Wilkommensnachricht'
    },
    {
      value: 'TM_INSTALLER_PASS',
      displayName: 'Inst. - Ausweis - HTML'
    },
    {
      value: 'TM_PASS_REJECTED',
      displayName: 'Inst. Ausweis abgelehnt'
    },
    {
      value: 'ORDER_CONFIRMATION_DELETE',
      displayName: 'HA-Anfrage - Geloescht'
    },
    {
      value: 'COM_BBS_APPROVAL',
      displayName: 'Inbtr. Schornsteinfeger Best.'
    },
    {
      value: 'COM_VALID',
      displayName: 'Inbtr. freigegeben.'
    },
    {
      value: 'COM_SUPPLY_DATE_APPOINTMENT',
      displayName: 'Inbtr. Wunschdatum anfordern.'
    },
    {
      value: 'COM_NEW_SUPPLY_APPOINTMENT_AGREED',
      displayName: 'Inbtr. New Wunschdatum vereinbaren.'
    },
    {
      value: 'TM_PASS_VALID',
      displayName: 'Inst. Ausweis freigegeben'
    },
    {
      value: 'TM_PASS_RENEWED',
      displayName: 'Inst. Ausweis verlängert'
    },
    {
      value: 'TM_GRID_REGISTRATION_VALID',
      displayName: 'Netzanmeldung freigegeben'
    },
    {
      value: 'TM_GRID_REGISTRATION_DECLINED',
      displayName: 'Netzanmeldung abgelehnt'
    },
    {
      value: 'TM_GRID_REGISTRATION_REQUEST_VALIDATION',
      displayName: 'Netzanmeldung Genehmigung angefordert'
    },
    {
      value: 'MAIL_FOOTER',
      displayName: 'Mail Footer'
    },
    {
      value: 'CUSTOMER_CSS',
      displayName: 'Mail CSS'
    },
    {
      value: 'FEEDER_CONTRACT',
      displayName: 'Einspeiservertrag'
    },
    {
      value: 'CONSTRUCTION_FILE',
      displayName: 'Bauakte'
    },
    {
      value: 'DATA_SHEET_HA_GASWATER',
      displayName: 'Erfassungsblatt Gas Wasser'
    },
    {
      value: 'ORDER_REVOCATION',
      displayName: 'Widerrufsformular'
    },
    {
      value: 'ORDER_REVOCATION_CONFIRMATION',
      displayName: 'Bestätigung Widerruf'
    },
    {
      value: 'ORDER_CONFIRMATION_INTRO',
      displayName: 'ORDER_CONFIRMATION_INTRO'
    },
    {
      value: 'OFFER_REQUEST_INTRO',
      displayName: 'OFFER_REQUEST_INTRO'
    },
    {
      value: 'COMMISSIONING_CHECK',
      displayName: 'Inbetriebnahme-Überprüfungsprotokoll'
    },
    {
      value: 'PV_REGISTRATION_FORM',
      displayName: 'PV Meldeformular'
    },
    {
      value: 'PLUGIN_GRID_REGISTRATION_APPROVED_METER',
      displayName: 'Steckerfertige Anlage - Freigabe mit Zählerwechsel'
    },
    {
      value: 'EXPLOSIVE_ORDNANCE_DISPOSAL_INFO',
      displayName: 'Anfrage Kampfmittelbeseitigung'
    }
  ];

  public getBusinessPartnerRoles() {
    return this.businessPartnerRoles;
  }

  businessPartnerRoles = [
    {
      value: BusinessPartnerTypeEnum.SERVICE_PROVIDER,
      displayName: 'Dienstleister',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.STATE_BUILDING_AUTHORITY,
      displayName: 'Landesbauamt',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.BUILDING_AUTHORITY,
      displayName: 'Bauverwaltung',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.INSTALLER,
      displayName: 'Installateur',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.CHIMNEY_SWEEPER,
      displayName: 'Schornsteinfeger',
      show: true
    }
  ];

  mailTemplateTypes: TemplateType[] = [
    // {
    //   value: 'DEFAULT',
    //   displayName: 'approvede Nachricht',
    // },
    // {
    //   value: 'OFFER_REQUEST_CONFIRMATION',
    //   displayName: 'Bestätigung Angebotsanfrage',
    // },
    {
      value: 'ORDER_CONFIRMATION',
      displayName: 'Bestellbestätigung'
    },
    // {
    //   value: 'ORDER_CONFIRMATION_REQUEST',
    //   displayName: 'Anfrage Vertragsbestätiung durch Kunden',
    // },
    {
      value: 'ORDER_CONFIRMATION_LETTER',
      displayName: 'Auftragsbestätigung - Anschreiben'
    },
    {
      value: 'ORDER_REQUEST_LETTER',
      displayName: 'Angebot - Anschreiben'
    },
    {
      value: 'CANCELLATION_LETTER',
      displayName: 'Absage - Anschreiben'
    },
    {
      value: 'BREAKUP_NOTICE',
      displayName: 'Aufbruchanzeige - Anschreiben'
    },
    {
      value: 'ORDER_REVOCATION',
      displayName: 'Widerrufsformular'
    },
    {
      value: 'ORDER_REVOCATION_CONFIRMATION',
      displayName: 'Bestätigung Widerruf'
    },
    {
      value: 'BUYING_CONTRACT',
      displayName: 'Kaufvertrag'
    },
    {
      value: 'FEEDER_CONTRACT',
      displayName: 'Einspeiservertrag'
    },
    {
      value: 'CONSTRUCTION_FILE',
      displayName: 'Bauakte'
    },
    {
      value: 'DATA_SHEET_HA_GASWATER',
      displayName: 'Erfassungsblatt Gas Wasser'
    },
    {
      value: 'COMMISSIONING_CHECK',
      displayName: 'Inbetriebnahme-Überprüfungsprotokoll'
    },
    {
      value: 'PV_REGISTRATION_FORM',
      displayName: 'PV Meldeformular'
    },
    {
      value: 'CONNECTION_CONTRACT_MAIL',
      displayName: 'Netzanschlussvertrag Mail'
    },
    {
      value: 'CONNECTION_CONTRACT',
      displayName: 'Netzanschlussvertrag Dokument'
    },
    {
      value: 'EXPLOSIVE_ORDNANCE_DISPOSAL_INFO',
      displayName: 'Anfrage Kampfmittelbeseitigung'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_TEMPWATER',
      displayName: 'Bestellbestätigung Bauwasser'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_TEMPPOWER',
      displayName: 'Bestellbestätigung Baustrom'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_GAS',
      displayName: 'Bestellbestätigung Gas - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_WATER',
      displayName: 'Bestellbestätigung Wasser - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_POWER',
      displayName: 'Bestellbestätigung Strom - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_METER_COLUMN',
      displayName: 'Bestellbestätigung Strom - Zähleranschlusssäule'
    },
    {
      value: 'ORDER_CONFIRMATION_WATER_METER_Q34',
      displayName: 'HA - Print Bestellbestätigung - Wasserzähler Q3_4'
    },
    {
      value: 'ORDER_CONFIRMATION_WATER_METER_Q310',
      displayName: 'HA - Print Bestellbestätigung - Wasserzähler Q3_10'
    },
    {
      value: 'ORDER_CONFIRMATION_GAS_HA_KASTEN',
      displayName: 'HA - Print Bestellbestätigung - Gas HA-Kasten'
    }
  ];

  public getMailTemplateFormats() {
    return this.mailTemplateFormats;
  }

  mailTemplateFormats = [
    {
      value: 'HTML_THYMELEAF',
      displayName: 'Html Template (Thymeleaf)'
    },
    {
      value: 'DOCX_STAMPER',
      displayName: 'Word Template (Stamper)'
    },
    {
      value: 'FAST_REPORT',
      displayName: 'FastReport'
    },
    {
      value: 'FILLABLE_PDF',
      displayName: 'Ausfüllbares PDF'
    }
  ];

  public getActivitiesStates() {
    return this.activitiesStates;
  }

  activitiesStates = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'OPEN',
      displayName: 'Ja'
    }
  ];

  public getSupplyAppointmentPartDayStatus() {
    return this.supplyAppointmentPartDayStatus;
  }

  supplyAppointmentPartDayStatus = [
    {
      value: '',
      displayName: 'Auswählen'
    },
    {
      value: SupplyAppointmentPartDayStatusEnum.Morning,
      displayName: 'Vormittags'
    },
    {
      value: SupplyAppointmentPartDayStatusEnum.Afternoon,
      displayName: 'Nachmittags'
    }
  ];

  public getTiefBauStates() {
    return this.tiefBauStates;
  }

  tiefBauStates = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'YES',
      displayName: 'Mit allen Tiefbauarbeiten'
    },
    {
      value: 'NO',
      displayName: 'Ohne Tiefbauarbeiten'
    },
    {
      value: 'PUBLIC_ONLY',
      displayName: 'Ohne Tiefbauarbeiten im privaten Bereich'
    }
  ];

  public getInstallerPassStatus() {
    return this.installerPassStatus;
  }

  installerPassStatus: StatusType[] = [
    {
      value: InstallerStatusEnum.PendingDocuments,
      displayName: 'Unvollständig',
      cssColor: '#ffcb6b'
    },
    {
      value: InstallerStatusEnum.DocumentsComplete,
      displayName: 'Dokumente Vollständig',
      cssColor: '#80cbc4'
    },
    {
      value: InstallerStatusEnum.ReadyToValidate,
      displayName: 'Bereit zur Prüfung',
      cssColor: '#80cbc4'
    },
    {
      value: InstallerStatusEnum.RequestValidation,
      displayName: 'Prüfung beantragt',
      cssColor: '#C792EA'
    },
    {
      value: InstallerStatusEnum.Invalid,
      displayName: 'Ungültig',
      cssColor: '#d5756c'
    },
    {
      value: InstallerStatusEnum.Valid,
      displayName: 'Gültig',
      cssColor: '#C3E88D'
    },
    {
      value: InstallerStatusEnum.Expired,
      displayName: 'Abgelaufen',
      cssColor: '#d5756c'
    },
    {
      value: InstallerStatusEnum.RequestRenew,
      displayName: 'Verlängerung angefordet',
      cssColor: '#d5756c'
    },
    {
      value: InstallerStatusEnum.FeedbackNeeded,
      displayName: 'Rückfrage',
      cssColor: '#f0b429'
    }
  ];

  public getNetworkOperator() {
    return this.networkOperatorList.networkOperatorData;
  }

  commonStatus: StatusType[] = [
    {
      value: CommissioningStatusEnum.Incomplete,
      displayName: 'Unvollständig',
      cssColor: '#f0b429'
    },
    {
      value: CommissioningStatusEnum.FeedbackNeeded,
      displayName: 'Rückfrage',
      cssColor: '#f0b429'
    },
    {
      value: CommissioningStatusEnum.ReadyToApprove,
      displayName: 'Bereit zu genehmigen',
      cssColor: '#e7ce06'
    },
    {
      value: CommissioningStatusEnum.Requested,
      displayName: 'Angefragt',
      cssColor: '#71dde3'
    },

    {
      value: CommonStatusEnum.UnderReview,
      displayName: 'In Prüfung',
      cssColor: '#71dde3'
    },
    {
      value: CommonStatusEnum.ReviewCompleted,
      displayName: 'techn. Prüfung erfolgt',
      cssColor: '#71dde3'
    },
    {
      value: CommissioningStatusEnum.Approved,
      displayName: 'Freigegeben',
      cssColor: '#C3E88D'
    },
    {
      value: CommissioningStatusEnum.Completed,
      displayName: 'Abgeschlossen',
      cssColor: '#e99aa6'
    },
    {
      value: CommissioningStatusEnum.Error,
      displayName: 'Fehler',
      cssColor: '#fd7e14'
    },
    {
      value: CommissioningStatusEnum.InstallationCompleted,
      displayName: 'Installation Fertig',
      cssColor: 'rgba(178,140,252,0.89)'
    }
  ];

  public getCommissioningRequestStatus() {
    return this.commissioningRequestStatus;
  }

  commissioningRequestStatus: StatusType[] = [
    ...this.commonStatus,
    {
      value: CommissioningStatusEnum.PendingAppointment,
      displayName: 'Warte auf Wunschtermin',
      cssColor: '#e7ce06'
    },
    {
      value: CommissioningStatusEnum.ChimneySweepConfirmationRequested,
      displayName: 'Bestätigung Schornsteinfeger angefragt',
      cssColor: '#71dde3'
    },
    {
      value: CommissioningStatusEnum.FeedbackNeededByChimneySweep,
      displayName: 'Rückfrage Schornsteinfeger',
      cssColor: '#f0b429'
    },
    {
      value: CommissioningStatusEnum.DefectReported,
      displayName: 'Mangelhaft gemeldet',
      cssColor: '#fd7e14'
    }
  ];

  public getGridRegistrationStatus() {
    return this.gridRegistrationStatus;
  }

  gridRegistrationStatus: StatusType[] = [
    ...this.commonStatus,
    {
      value: GridRegistrationStatusEnum.Declined,
      displayName: 'Abgelehnt',
      cssColor: '#fd7e14'
    },
    {
      value: GridRegistrationStatusEnum.PlaceInServiceConfirmationRequest,
      displayName: 'Warten auf Bestätigung durch Kunde',
      cssColor: '#71dde3'
    },
    {
      value: GridRegistrationStatusEnum.PlacedInServiceConfirmation,
      displayName: 'Inbetriebsetzung bestätigt',
      cssColor: '#71dde3'
    },
    {
      value: GridRegistrationStatusEnum.WaitingForCustomerFeedInOrder,
      displayName: 'Bestellung Einspeisemanagement ausstehend',
      cssColor: '#71dde3'
    },
    {
      value: GridRegistrationStatusEnum.ConfiguringFeedInManagement,
      displayName: 'Bereitstellung Einspeisermgmt',
      cssColor: '#71dde3'
    },
    {
      value: GridRegistrationStatusEnum.PendingAssignTechnician,
      displayName: 'Installateur noch nicht zugewiesen',
      cssColor: '#71dde3'
    },
    {
      value: GridRegistrationStatusEnum.NeedMeterChange,
      displayName: 'Zählerwechsel notwendig',
      cssColor: '#C3E88D'
    },
    {
      value: GridRegistrationStatusEnum.Expired,
      displayName: 'Abgelaufen',
      cssColor: '#C3E88D'
    }
  ];

  public getFeederContractStatus() {
    return this.feederContractStatus;
  }

  feederContractStatus: StatusType[] = [
    {
      value: FeederContractStatusEnum.ToBeCreated,
      displayName: 'in Erstellung',
      cssColor: '#f0b429'
    },
    {
      value: FeederContractStatusEnum.Created,
      displayName: 'Offen',
      cssColor: '#71dde3'
    },
    {
      value: FeederContractStatusEnum.TechnicallyReviewed,
      displayName: 'Fachlich geprüft',
      cssColor: '#C3E88D'
    },
    {
      value: FeederContractStatusEnum.ConfirmationRequestedByMail,
      displayName: 'Vertragsangebot per E-Mail versandt',
      cssColor: '#e7ce06'
    },
    {
      value: FeederContractStatusEnum.ClosedWithoutFeedback,
      displayName: 'Ohne Kundenfeedback geschlossen',
      cssColor: '#e7ce06'
    },
    {
      value: FeederContractStatusEnum.FeedbackNeeded,
      displayName: 'Rückfrage',
      cssColor: '#f0b429'
    },
    {
      value: FeederContractStatusEnum.Accepted,
      displayName: 'Akzeptiert',
      cssColor: '#e7ce06'
    },
    {
      value: FeederContractStatusEnum.Confirmed,
      displayName: 'Bestätigt',
      cssColor: '#71dde3'
    },
    {
      value: FeederContractStatusEnum.Cancelled,
      displayName: 'Storniert',
      cssColor: '#e99aa6'
    },
    {
      value: FeederContractStatusEnum.Completed,
      displayName: 'Abgeschlossen',
      cssColor: '#e99aa6'
    }
  ];

  public getRequestStatus() {
    return this.requestStatusTypes;
  }

  requestStatusTypes: StatusType[] = [
    ...this.commissioningRequestStatus,
    ...this.gridRegistrationStatus,
    ...this.feederContractStatus,
    ...ConnectionChangeRequestStatusConstant
  ];

  public getrRelatedGRtoCRTypes() {
    return this.relatedGRtoCRTypes;
  }

  relatedGRtoCRTypes = [
    {
      value: 'noApproved',
      displayName: 'Nicht freigegeben'
    }
  ];

  getActionFilterOptions() {
    return [...CommissioningPowerActionTypeEnum, ...CommissioningPowerMeterTypeConstant];
  }
}
